import { useCallback, useRef } from 'react';

/**
 *
 * @param delayTime
 * @returns
 */
export function useSingleFetch(delayTime: number = 1000) {
  const isRequestPerforming = useRef(false);
  return useCallback(
    (promiseFn: () => Promise<any>) => {
      if (!isRequestPerforming.current) {
        isRequestPerforming.current = true;
        promiseFn().finally(() => {
          setTimeout(() => {
            isRequestPerforming.current = false;
          }, delayTime);
        });
      }
    },
    [delayTime],
  );
}
